import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'app-devanbuttonrender',
  template: `
  <span *ngIf="label == 'UPDATE DEVAN PLAN'"   (click)="updateDevanPlan('value')"
  [class.disabled]="isDisable" 
  [ngClass]="{ 'disable': isDisable }"
  class="badge complete">{{ label }}
 </span>

  `,
  styles: [
    `
      .badge {
        width: 140px;
        font-size: 12px;
        border-radius: 35px;
        font-weight: 600;
        cursor:pointer;

      }
      .complete {
        color: #22b785;
        border: 1px solid #22b785;
        cursor: pointer;
      }
      .badgeerror {
        background-color: #000000;
        border: 1px solid #000000;
        cursor:pointer;

      }
      .disabled {
        pointer-events: none;
        opacity: 0.6; 
    }
    
    `,
  ],
})
export class UpdateDevanPlanPPComponent implements ICellRendererAngularComp {
  params;
  label: string;
  isDisable: boolean;
  showbutton: boolean = false;
  access;

  agInit(params): void {
    this.params = params;
    console.log("devannutton", params);
    this.access = JSON.parse(localStorage.getItem('prodProgress'));

    // this.label="DEVAN";

    this.params = params;
    this.label = "UPDATE DEVAN PLAN";
    console.log("this.params",this.params)


    if (this.params.data.is_recalculate) {
      console.log("inside is recalate")
      this.isDisable=false
      this.label = "UPDATE DEVAN PLAN";
    }else{
    this.isDisable=true}

    // if (this.params.data.container_status == 'USER DEVANNED') {
    //   this.label = "UNDEVAN";
    // }
  

  }

  refresh(params?: any): boolean {
    return true;
  }

  onClick($event) {
    if (this.params.onClick instanceof Function) {
      // put anything into params u want pass into parents component
      const params = {
        event: $event,
        rowData: this.params.node.data,
        // ...something
      };
      this.params.onClick(params);
    }
  }
  updateDevanPlan(value) {

    this.params.context.componentParent.updateDevanPlan(
      this.params.data
    );

  }
  undevan(value) {
    this.params.context.componentParent.undevan(
      this.params.data
    );

  }
}
